import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly darkThemeClass = 'dark-theme';
  private readonly lightThemeClass = 'light-theme';

  public enableDarkTheme(): void {
    document.body.classList.add(this.darkThemeClass);
    document.body.classList.remove(this.lightThemeClass);
    localStorage.setItem('theme', 'dark');
  }

  public disableDarkTheme(): void {
    document.body.classList.remove(this.darkThemeClass);
    document.body.classList.add(this.lightThemeClass);
    localStorage.setItem('theme', 'light');
  }

  public toggleTheme(): string {
    let theme = '';
    if (document.body.classList.contains(this.darkThemeClass)) {
      this.disableDarkTheme();
      theme = 'light';
    } else {
      this.enableDarkTheme();
      theme = 'dark';
    }
    return theme;
  }

  public loadTheme(): string | null {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      this.enableDarkTheme();
    } else {
      this.disableDarkTheme();
    }
    return savedTheme;
  }
}
